import { useState, useEffect, useContext } from 'react';
import { BreadCrumb } from 'primereact/breadcrumb';
import { Button } from 'primereact/button';
import { Chip } from 'primereact/chip';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { ExportPageData } from 'components/ExportPageData';
import { FilterTags } from 'components/FilterTags';
import { InputText } from 'primereact/inputtext';
import { Link } from 'react-router-dom';
import { PageRequestError } from 'components/PageRequestError';
import { Paginator } from 'primereact/paginator';
import { ProgressSpinner } from 'primereact/progressspinner';
import { SplitButton } from 'primereact/splitbutton';
import { Title } from 'components/Title';
import PedidosEditPage from 'pages/pedidos/Edit';
import useApp from 'hooks/useApp';
import useUtils from 'hooks/useUtils';
import useListPage from 'hooks/useListPage';
import MultiSelectGroup from 'pages/custom/MultiSelectGroup';
import Utils from 'helpers/helper.util';
import useApi from 'hooks/useApi';

const LiberacoesTotem = (props) => {
    const app = useApp();
    const api = useApi();
    const useutils = useUtils();
    const utils = Utils();
    const { empid, setempid } = useApp();

    const filterSchema = {
        search: {
            tagTitle: "Search",
            value: '',
            valueType: 'single',
            options: [],
        }
    }
    const pageController = useListPage(props, filterSchema);
    const filterController = pageController.filterController;
    const { records, pageReady, loading, selectedItems, apiUrl, currentRecord, sortBy, sortOrder, apiRequestError, setSelectedItems, getPageBreadCrumbs, onSort, deleteItem, setCurrentRecord, pagination } = pageController;
    const { filters, setFilterValue } = filterController;
    const { totalRecords, totalPages, recordsPosition, firstRow, limit, onPageChange } = pagination;
    const [startDate, setStartDate] = useState(utils.FirstDateOfCurrentMonth());
    const [endDate, setEndDate] = useState(utils.LastDateOfCurrentMonth());
    const [funcionarios, setFuncionarios] = useState([]);
    const [gestorid, setGestorId] = useState(null);
    const [liberacoes, setLiberacoes] = useState([]);

    const fetchFuncionarios = async () => {
        try {
            let endpoint = 'pedidos/listegestoresliberacao';
            const response = await api.get(endpoint);
            setFuncionarios(response.data);
        } catch (error) {
            console.error('Erro ao buscar funcionários:', error);
        }
    };

    useEffect(() => {
        fetchFuncionarios();
    }, [empid]);


    useEffect(() => {
        fetchFuncionarios();
    }, []);

    useEffect(() => {
        const fetchLiberacoes = async () => {
            try {
                let endpoint = `pedidos/liberacao/${gestorid}/${startDate}/${endDate}`;
                const response = await api.get(endpoint);
                console.log("GESTOR", gestorid);
                setLiberacoes(response.data);
            } catch (error) {
                console.error('Erro ao buscar liberacoes:', error);
            }
        }
        if (gestorid) {
            fetchLiberacoes();
        } 
    }, [gestorid, startDate, endDate]);



    function ActionButton(data) {
        const items = [
            {
                label: "Editar",
                command: (event) => { app.openPageDialog(<PedidosEditPage isSubPage apiPath={`/pedidos/edit/${data.id}`} />, { closeBtn: true }) },
                icon: "pi pi-pencil"
            },
            {
                label: "Excluir",
                command: (event) => { deleteItem(data.id) },
                icon: "pi pi-trash"
            }
        ]
        let shouldShowButton = data.status == "A";
        return shouldShowButton ?
            (<SplitButton dropdownIcon="pi pi-bars" className="dropdown-only p-button-text p-button-plain" model={items} />)
            : null;
    }


    function bodyId(data) {
        if (data) {
            return (
                <Link to={`/`}> {data.id}</Link>
            );
        }
    }
    function bodyRazaoSocial(data) {
        if (data) {
            return (
                <>{data.empresas_razaosocial}</>
            );
        }
    }

    function bodyFuncionario(data) {
        if (data) {
            return (
                <>{data.funcionarios_nome}</>
            );
        }
    }

    function bodyStatus(data) {
        if (data) {
            return (
                <>
                    <Chip
                        label={
                            app.ChooseItem(
                                data.status,
                                [
                                    { valor: 'A', titulo: 'Aberto' },
                                    { valor: 'C', titulo: 'Cancelado' },
                                    { valor: 'F', titulo: 'Finalizado' }
                                ])
                        }
                    />
                </>
            );
        }
    }

    function bodyTipo(data) {
        if (data) {
            return (
                <><Chip label={
                    app.ChooseItem(
                        data.tipo,
                        [
                            { valor: 'E', titulo: 'Entrada' },
                            { valor: 'S', titulo: 'Saída' },
                            { valor: 'T', titulo: 'Terminal' },
                        ])
                }
                />
                </>
            );
        }
    }

    const OnClickPrintPedido = (param) => {
        if (param) {
            var paramns = { id: 2, filter: `pedido|id|${param.id}|0|0` };
            app.openPageDialog(<app.PrintPreview paramns={paramns} />, { maximized: true, closeBtn: true, width: '80vw' })
        }
    };

    function bodyPrint(data) {
        if (data) {
            let shouldShowButton = data.status == "F";
            return shouldShowButton ? (
                <app.PrintButton onClick={() => OnClickPrintPedido(data)} />
            ) : null;
        }
    }

    function bodyData(data) {
        if (data) {
            return app.FmtDateBR(data.libDate)
        }
    }


    function bodyCurr(data) {
        return app.FmtCurr(data)
    }

    function bodyQtde(data) {
        return app.FmtQtd(data)
    }


    function PageLoading() {
        if (loading) {
            return (
                <>
                    <div className="flex align-items-center justify-content-center text-gray-500 p-3">
                        <div><ProgressSpinner style={{ width: '50px', height: '50px' }} /> </div>
                        <div className="font-bold text-lg">Carregando...</div>
                    </div>
                </>
            );
        }
    }
    function EmptyRecordMessage() {
        if (pageReady && !records.length) {
            return (
                <div className="text-lg mt-3 p-3 text-center text-400 font-bold">
                    Nenhum Registro Encontrado
                </div>
            );
        }
    }
    function MultiDelete() {
        if (selectedItems.length) {
            return (
                <div className="m-2 flex-grow-0">
                    <Button onClick={() => deleteItem(selectedItems)} icon="pi pi-trash" className="p-button-danger" title="Excluir selecionado" />
                </div>
            )
        }
    }
    function ExportData() {
        if (props.exportData && records.length) {
            const downloadFileName = `${useutils.dateNow()}-pedidos`;
            return (
                <div className="m-2">
                    <ExportPageData csv={false} pageUrl={apiUrl} downloadFileName={downloadFileName} butonLabel="Exportar" tooltip="Exportar" buttonIcon="pi pi-print" />
                </div>
            );
        }
    }
    function PagerControl() {
        if (props.paginate && totalPages > 1) {
            const pagerReportTemplate = {
                layout: pagination.layout,
                CurrentPageReport: (options) => {
                    return (
                        <>
                            <span className="text-sm text-gray-500 px-2">Registros <b>{recordsPosition} do {options.totalRecords}</b></span>
                        </>
                    );
                }
            }
            return (
                <div className="flex-grow-1">
                    <Paginator first={firstRow} rows={limit} totalRecords={totalRecords} onPageChange={onPageChange} template={pagerReportTemplate} />
                </div>
            )
        }
    }
    function PageActionButtons() {
        return (
            <div className="flex flex-wrap">
                <MultiDelete />
                <ExportData />
            </div>
        );
    }
    function PageFooter() {
        if (pageReady && props.showFooter) {
            return (
                <div className="flex flex-wrap">
                    <PageActionButtons />
                    <PagerControl />
                </div>
            );
        }
    }
    function PageBreadcrumbs() {
        if (props.showBreadcrumbs) {
            const items = getPageBreadCrumbs();
            return (items.length > 0 && <BreadCrumb className="mb-3" model={items} />);
        }
    }
    if (apiRequestError) {
        return (
            <PageRequestError error={apiRequestError} />
        );
    }

    const handleFuncChange = (e) => {
        setGestorId(e.value);
    }

    const headerTemplate = (data) => {
        return (
            <div className="flex align-items-center gap-2">
                <span className="font-bold text-2xl text-primary">{data.employeeName}</span>
            </div>
        );
    };

    const footerTemplate = (data) => {
        return (
            <>
                <td colSpan="5">
                    <div className="flex justify-content-end font-bold w-full">Total de Liberações: {calculateCustomerTotal()}</div>
                </td>
            </>
        );
    };

    const calculateCustomerTotal = () => {
        let total = 0;
        if (liberacoes) {
            for (let liberacao of liberacoes) {
                total += liberacao.quantity + liberacao.localQuantity;
            }
        }
        return total;
    };  

    const OnClickList = () => {
        let paramn1 = { id: 6, filter: `v_ped_liberacoes|empid|${6}|0|0` };
        let paramn2 = { id: 6, filter: `v_ped_liberacoes|lib_d|${startDate}|3|0` };
        let paramn3 = { id: 6, filter: `v_ped_liberacoes|lib_d|${endDate}|5|0` };
        let paramns = [paramn1, paramn2, paramn3];
        app.openPageDialog(<app.PrintPreview paramns={paramns} />, { maximized: true, closeBtn: true, width: '80vw' })
    };


    return (
        <main id="LiberacoesTotem" className="main-page">
            {(props.showHeader) &&
                <section className="page-section mb-3">
                    <div className="container-fluid">
                        <div className="grid justify-content-between align-items-center">
                            <div className="col">
                                <Title title="Liberações Realizadas por Gestores" titleClass="text-2xl text-primary font-bold" subTitleClass="text-500" separator={false} />
                            </div>

                            <div className="col-12 md:col-12">

                                <div className="grid align-items-center">
                                    <div className="col-12 md:col-8">
                                        <span className="p-input-icon-left w-full">
                                            <i className="pi pi-user" />
                                            <label className="font-bold text-primary">Lista de Gestores</label>
                                            <MultiSelectGroup
                                                name="gestorid"
                                                multiSelect={false}
                                                onChange={(e) => handleFuncChange(e)}
                                                // onFilter={handleFilter}
                                                DataList={[...funcionarios]}
                                                fields={{ label: "label", value: "value" }}
                                                disabled={app.auth.isemployee}
                                            />
                                        </span>
                                    </div>

                                    <div className="col-12 md:col-2">
                                        <span className="p-input-icon-left w-full">
                                            <i className="pi pi-calendar" />
                                            <InputText
                                                type="date"
                                                value={startDate}
                                                onChange={(e) => setStartDate(e.target.value)}
                                                placeholder="Data Inicial"
                                                className="w-full"
                                            />
                                        </span>
                                    </div>

                                    <div className="col-12 md:col-2">
                                        <span className="p-input-icon-left w-full">
                                            <i className="pi pi-calendar" />
                                            <InputText
                                                type="date"
                                                value={endDate}
                                                onChange={(e) => setEndDate(e.target.value)}
                                                placeholder="Data Final"
                                                className="w-full"
                                            />
                                        </span>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>
            }
            <section className="page-section " >
                <DataTable
                    value={liberacoes}
                    dataKey="id"
                    rowGroupMode="subheader"
                    rowGroupHeaderTemplate={headerTemplate}
                    rowGroupFooterTemplate={footerTemplate}
                    groupRowsBy="representative.name"
                >
                    {/*PageComponentStart*/}
                    <Column headerStyle={{ width: '5%' }} header="Data" body={bodyData} align='center'></Column>
                    <Column headerStyle={{ width: '5%' }} field="libTime" header="Hora" align='center'></Column>
                    <Column headerStyle={{ width: '5%' }} field="externalCode" header="COD" align='center'></Column>
                    <Column headerStyle={{ width: '40%' }} field="productName" header="Nome" align='left'></Column>
                    <Column headerStyle={{ width: '5%' }} field="quantity" header="Eletro" align='right' body={(x) => bodyQtde(x.quantity)}></Column>
                    <Column headerStyle={{ width: '5%' }} field="localQuantity" header="Cliente" align='right' body={(x) => bodyQtde(x.localQuantity)}></Column>
                    <Column headerStyle={{ width: '5%' }} field="unitPrice" header="Unit" align='right' body={(x) => bodyCurr(x.unitPrice)}></Column>
                    <Column headerStyle={{ width: '5%' }} field="total" header="Total" align='right' body={(x) => bodyCurr(x.total)}></Column>

                </DataTable>
				<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '1rem' }}>
                    {liberacoes.length > 0 && (
                        <app.PrintButton onClick={() => OnClickList()} label="Imprimir Listagem"/>
                    )}
				</div>

            </section>
        </main>
    );
}
LiberacoesTotem.defaultProps = {
    primaryKey: 'id',
    pageName: 'LiberacoesTotem',
    apiPath: 'pedidos/index',
    routeName: 'pedidoslist',
    msgBeforeDelete: "Tem certeza de que deseja excluir este registro?",
    msgTitle: "Apagar registro",
    msgAfterDelete: "Registro excluído com sucesso",
    showHeader: true,
    showFooter: true,
    paginate: true,
    isSubPage: false,
    showBreadcrumbs: true,
    exportData: true,
    importData: false,
    keepRecords: false,
    multiCheckbox: true,
    search: '',
    fieldName: null,
    fieldValue: null,
    sortField: '',
    sortDir: '',
    pageNo: 1,
    limit: 10,
}

export default LiberacoesTotem;